import { Component, OnInit } from '@angular/core';
import { UserService } from "../services/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AssetsService } from "../services/assets.service";
import { NotificationsService } from "angular2-notifications";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner"
import { PuserserviceService } from "../services/puserservice.service";
import { PagerserviceService } from "../services/pagerservice.service";
import { AdminService } from "../services/admin.service";
import * as XLSX from 'xlsx';

@Component({
    selector: 'app-loginactivity',
    templateUrl: './loginactivity.component.html',
    styleUrls: ['./loginactivity.component.css']
})
export class LoginactivityComponent implements OnInit {

    adminLogin: Array<any>;
    FilPerpage: number;
    FilPage: number;
    pager: number;
    Tpager: number;
    UId: string;
    fileName: string;
    // pager object
    pager1: any = {};
    clientActivation: Boolean;
    admindetails = {
        _id: ''
    };
    activitydetail = {
        ipaddress: '',
        status: '',
        _csrf: '',
        username: ''
    }
    searchObj = {
        time1: new Date(),
        time: new Date()
    }
    permission: string;
    currentPag: any = 0;
    adminLoginlist: Array<any> = [];
    constructor(private router: Router, private userService: UserService,
        private assetService: AssetsService,
        private spinnerService: Ng4LoadingSpinnerService,
        private notifSer: NotificationsService,
        private pagerService: PagerserviceService,
        private pusherService: PuserserviceService, private route: ActivatedRoute,
        private adminService: AdminService,
        ) { }

    ngOnInit() {
        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/index');
        } else {
            this.admindetails = this.userService.getUserDetails();

            let id = this.route.snapshot.paramMap.get('id');
            if (typeof id !== 'undefined' && id) {
                this.UId = id;
                this.clientActivation = false;
            } else {
                this.UId = this.admindetails._id;
                this.clientActivation = true;
            }
            this.FilPerpage = 10;
            this.FilPage = 1;
            this.pager = 1;
            this.adminService.groupupdate.subscribe(permData => {
                localStorage.setItem('permission', permData.permission);
                this.permission = permData.permission
            });
            this.permission = this.adminService.getPermission();
            this.getAdminloginActivity();
            this.csrf();
        }
    }
    csrf() {
        this.userService.csrf().subscribe((success) => {
            this.activitydetail._csrf = success._csrf;
            this.getUserLogs();
        }, (error) => {
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    getAdminloginActivity() {
        this.spinnerService.show();
        let payload = {
            userid: this.UId,
            perpage: this.FilPerpage,
            page: this.FilPage,
            search: this.searchObj.time,
        }
        this.userService.getLoginActivityList(payload).subscribe(list => {
            console.log("login list====", list);
            if (list.status) {
                this.adminLogin = list.logs;
                this.Tpager = list.pages;
                this.currentPag = list.current
                this.setPage(this.FilPage);
                this.adminLoginlist = []
                this.adminLogin.forEach(element => {
                    console.log(element);
                    this.adminLoginlist.push({
                        'Login Time': element.createdAt,
                        'IP': element.ipaddress,
                        'Action': element.action_name,
                        'ADMIN AGENT': element.agent,
                        'Device Type': element.type,
                        'Device Model': element.model
                    })
                });
            }
            this.spinnerService.hide();
        }, (err) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Error ',
                err.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }


    setPage(page: number) {
        // get pager object from service
        this.pager1 = this.pagerService.getPager(this.Tpager, page);
    }

    setPageOnClick(page: number) {
        this.pager = page;
        this.FilPage = page;
        this.getAdminloginActivity();
    }
    IpStatus(ip, status, name) {
        console.log(ip, status);
        this.activitydetail.ipaddress = ip;
        this.activitydetail.status = status;
        this.activitydetail.username = name;
        this.adminService.changeIpStatus(this.activitydetail).subscribe((data) => {
            console.log(data);
            var ipobj = {
                ip_addr: '',
                status: ''
            }
            ipobj.ip_addr = ip;
            ipobj.status = '0'

            this.getAdminloginActivity();
            this.notifSer.success(
                'Success ',
                data.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        }, (err) => {
            this.notifSer.error(
                'Error ',
                err.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }
    getLogsExp() {
        console.log('rerere');
        this.fileName = 'LoginLogs.xlsx'
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.adminLoginlist);
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */
        XLSX.writeFile(wb, this.fileName);
    }
    getUserLogs() {
        this.getAdminloginActivity();
    }
}



// WEBPACK FOOTER //
// ./src/app/loginactivity/loginactivity.component.ts